<div class="side-nav-block">
    <div class="side-nav-section" [ngClass]="{ 'side-nav-section-closed': !show_side_nav }" >
        <div class="logo-section">
            <img src="assets/logo-short.png" class="small-logo" *ngIf="!show_side_nav" />
            <img src="assets/login.png" class="side-nav-logo" *ngIf="show_side_nav" />
            <!-- <img src="assets/rg_logo.png" class="side-nav-logo" *ngIf="show_side_nav" /> -->
        </div>
        <div class="profile-section">
            <div class="profile-image-section">
                <img src="{{ profile_image }}" onerror="this.src='assets/photo.jpg'" class="profile-image" [ngClass]="{ 'profile-image-closed': !show_side_nav }" />
            </div>
            <div class="profile-details" *ngIf="show_side_nav">
                <!-- <p class="pointer" (click)="navigateToProfile()">{{user_details.first_name}} {{user_details.last_name}}</p> -->
                <p class="profile-name">{{ user_details.first_name }} {{ user_details.last_name }}</p>
                <div class="profile-role-section">
                    <i class="fa fa-pencil edit-profile-icon" (click)="toggleRoleSelection()" ></i>
                    <div class="profile-role-edit-section" *ngIf="show_role_details">
                        <div class="profile-edit-link-section">
                            <span class="profile-edit-link" (click)="navigateToProfile()">Edit Profile</span>
                        </div>
                        <div class="profile-edit-link-section">
                            <span class="profile-edit-link" (click)="profilePicture.click()">Update Profile Picture</span>
                            <input type="file" accept=".jpeg, .png, .jpg" #profilePicture (change)="uploadProfilePicture($event)" style="display: none" />
                        </div>
                        <div class="profile-change-role-section">
                            <p class="profile-change-role-label">Change Role</p>
                            <mat-select class="profile-change-role-input" [(ngModel)]="selected_role">
                                <mat-option *ngFor="let role of user_details.roles" [value]="role.role" (click)="roleSelected(role)">{{ role.role_name }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <p class="profile-details-role">{{ user_details.role.role_name }}</p>
            </div>
        </div>
        <div class="navigation-section">
            <div class="navigation-heading" (click)="navigateToDashboard()">
                <img src="assets/side-navigation/home.png" class="user-nav-icon" />
                <span *ngIf="show_side_nav">Home</span>
            </div>
            <div class="each-navigation-heading" *ngFor="let nav of nav_data">
                <div class="navigation-heading" (click)="nav.show_menu = !nav.show_menu" >
                    <img src="{{ nav.icon }}" class="user-nav-icon" *ngIf="!nav.show_menu" />
                    <img src="{{ nav.activeIcon }}" class="user-nav-icon" *ngIf="nav.show_menu" />
                    <span [ngClass]="{ 'nav-selected': nav.show_menu }" *ngIf="show_side_nav">{{ nav.name }}</span>
                    <img src="assets/side-section-open.png" class="nav-arrow-icon nav-arrow-expand" *ngIf="!nav.show_menu && show_side_nav" />
                    <img src="assets/side-section-close.png" class="nav-arrow-icon" *ngIf="nav.show_menu && show_side_nav" />
                </div>
                <div *ngIf="nav.show_menu">
                    <div class="each-sub-menu" *ngFor="let sub_nav of nav.sub" (click)="navigate(sub_nav.route)" [ngClass]="{'each-sub-menu-selected': selected_route == sub_nav.route, 'inner-menu': sub_nav.inner}" >
                        <img src="{{ sub_nav.activeIcon }}" *ngIf=" nav.show_menu && sub_nav.icon && selected_route == sub_nav.route " class="user-nav-icon" [matTooltip]="sub_nav.name" [matTooltipPosition]="'right'" />
                        <img src="{{ sub_nav.icon }}" *ngIf=" nav.show_menu && sub_nav.icon && selected_route != sub_nav.route " class="user-nav-icon" [matTooltip]="sub_nav.name" [matTooltipPosition]="'right'" />
                        <span [ngClass]="{ 'nav-selected': selected_route == sub_nav.route }" *ngIf="show_side_nav && nav.show_menu" >{{ sub_nav.name }}</span >

                        <div class="each-sub-menu" *ngFor="let inner_sub_nav of sub_nav.sub" (click)="navigate(inner_sub_nav.route)" [ngClass]="{'each-sub-menu-selected': selected_route == inner_sub_nav.route, 'inner-menu': inner_sub_nav.inner }" >
                            <img src="{{ inner_sub_nav.activeIcon }}" *ngIf=" nav.show_menu && inner_sub_nav.icon && selected_route == inner_sub_nav.route " class="user-nav-icon" [matTooltip]="inner_sub_nav.name" [matTooltipPosition]="'right'" />
                            <img src="{{ inner_sub_nav.icon }}" *ngIf=" nav.show_menu && inner_sub_nav.icon && selected_route != inner_sub_nav.route " class="user-nav-icon" [matTooltip]="inner_sub_nav.name" [matTooltipPosition]="'right'" />
                            <span [ngClass]="{'nav-selected': selected_route == inner_sub_nav.route }" *ngIf="show_side_nav && nav.show_menu" >{{ inner_sub_nav.name }}</span >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="navigation-heading" (click)="logout()">
            <img src="assets/side-navigation/logout.png" class="user-nav-icon" [matTooltip]="'Logout'" [matTooltipPosition]="'right'" />
            <span *ngIf="show_side_nav">Logout</span>
        </div>
    </div>
    <div class="toggle-navigation-section" (click)="toggleNav()">
        <img src="assets/arrow-right.png" [ngClass]="{ 'close-nav': !show_side_nav }" />
    </div>
</div>
